export const SAVE_USER_ID_START = 'SAVE_USER_ID_START';
export const SAVE_USER_ID_SUCCESS = 'SAVE_USER_ID_SUCCESS';
export const SAVE_USER_ID_ERROR = 'SAVE_USER_ID_ERROR';
export const CLEAR_SAVE_USER_ID_STORE = 'CLEAR_SAVE_USER_ID_STORE';
